import { render } from "./FlashNews.vue?vue&type=template&id=85c23a96&scoped=true"
import script from "./FlashNews.vue?vue&type=script&lang=js"
export * from "./FlashNews.vue?vue&type=script&lang=js"

import "./FlashNews.vue?vue&type=style&index=0&id=85c23a96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85c23a96"]])

export default __exports__